"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Error = void 0;

var _react = _interopRequireDefault(require("react"));

var _Label = _interopRequireDefault(require("./Label"));

var _Flex = _interopRequireDefault(require("./Flex"));

var _Text = _interopRequireDefault(require("./Text"));

var _Input = _interopRequireWildcard(require("./Input"));

var _Slider = _interopRequireDefault(require("./Slider"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: normal;\n  &:before {\n    content: '\u2014 ';\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Error = (0, _styledComponents["default"])(_Text["default"]).attrs({
  className: 'error',
  color: 'error',
  fontSize: 1,
  ml: 1,
  my: 0
})(_templateObject());
exports.Error = Error;

var Field = function Field(_ref) {
  var type = _ref.type,
      name = _ref.name,
      label = _ref.label,
      placeholder = _ref.placeholder,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, ["type", "name", "label", "placeholder", "error"]);

  var Component = {
    select: _Input.InputSelect,
    slider: _Slider["default"],
    textarea: _Input.InputTextarea
  }[type] || _Input["default"];
  return _react["default"].createElement(_Label["default"], {
    className: type,
    id: name,
    mb: 2
  }, _react["default"].createElement(_Flex["default"], {
    align: "center",
    mb: "2px",
    wrap: true
  }, label, error && _react["default"].createElement(Error, {
    children: error
  })), _react["default"].createElement(Component, _extends({
    name: name,
    type: type,
    placeholder: placeholder
  }, props)));
};

Field.displayName = 'Field';
Field.propTypes = {
  /** choose alternate field type (like email, password, textarea, or select) */
  type: _propTypes["default"].oneOf(['checkbox', 'date', 'email', 'file', 'number', 'password', 'select', 'tel', 'textarea', 'url', 'text']),
  name: _propTypes["default"].string.isRequired,

  /** label text */
  label: _propTypes["default"].string.isRequired,

  /** validation message */
  error: _propTypes["default"].string,

  /** placeholder text */
  placeholder: _propTypes["default"].string
};
Field.defaultProps = {
  theme: _theme["default"],
  type: 'text'
};
var _default = Field;
exports["default"] = _default;